export default class{
    static timeZones = [
        {
            moment: 'Australia/Sydney',
            cSharp: 'AUS Eastern Standard Time',
        },
        {
            moment: 'Australia/Sydney',
            cSharp: 'E. Australia Standard Time',
        },
        {
            moment: 'Australia/Adelaide',
            cSharp: 'AUS Central Standard Time',
        },
        {
            moment: 'Australia/Adelaide',
            cSharp: 'Cen. Australia Standard Time',
        },
        {
            moment: 'Australia/Perth',
            cSharp: 'W. Australia Standard Time',
        },
        {
            moment: 'Pacific/Auckland',
            cSharp: 'New Zealand Standard Time',
        },
    ];

    static getFromCSharpTimezone(timezone){
        for(var ii = 0; ii < this.timeZones.length; ii++){
            if(this.timeZones[ii].cSharp === timezone){
                return this.timeZones[ii].moment;
            }
        }
        return null;
    }

}


// WEBPACK FOOTER //
// ./src/utils/timezone.js